///////////////////////////////////////////////////////////////////
// Author: Ron Tutone
// Description: display case details for the civil case selected
///////////////////////////////////////////////////////////////////
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChange } from '@angular/core';
import { CivilCase } from './../../civil/civil-case';
import { environment } from './../../../environments/environment';
import { CivilSearchService } from './../../civil/civil-search.service';

@Component({
  selector: 'app-civil-case-view',
  templateUrl: './civil-case-view.component.html',
  styleUrls: ['./civil-case-view.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CivilCaseViewComponent implements OnChanges {

  @Input() civilCase: CivilCase;
  private abstractCode: string;
  private showFieldCodeFlag = false;
  showFieldCodeAction = 'Click to show field code';
  tocOpen = true;

  constructor(private cd: ChangeDetectorRef,
              private civilSearchService: CivilSearchService) { }

  /**
    * set the flags when the civil was pushed to this compoment
    * @param changes ;
    */
    ngOnChanges(changes: { [propName: string]: SimpleChange}) {
      // loading the last update date
      if (changes['civilCase'] && this.civilCase) {
        this.getSearchRecordLastUpdateDate();
      }
   }

  getAbstractJQCode(code: string): string {
    return code;
  }

  showFieldCode() {
    // toggle the flag
    this.showFieldCodeFlag = !this.showFieldCodeFlag;

    // show/hide the field codes
    if (this.showFieldCodeFlag) {
      $('.field-code').show();
      this.showFieldCodeAction = 'Click to hide field code';
    } else {
      $('.field-code').hide();
      this.showFieldCodeAction = 'Click to show field code';
    }
  }

  toggleTableOfContents() {
    this.tocOpen = !this.tocOpen;
  }

  isProd(): boolean {
    return environment.production;
  }

  /**
   * get the last update date and notity of it through event service
   */
  getSearchRecordLastUpdateDate() {
    this.civilSearchService.getSearchRecordLastUpdateDate()
    .subscribe(lastUpdateDate => {
       this.civilCase.searchRecordLastUpdateDate = lastUpdateDate;
       this.cd.markForCheck();   // force to detect the changes
    });
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/civil-case-view.component.ts